"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFulfillmentConfigurationsList = exports.fetchFulfillmentConfigurationResourceByLink = exports.fetchFulfillmentConfigurationAssociations = exports.errorHandler = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _lodash = require("lodash");

var _constants = require("../shared/constants");

var _i18n = _interopRequireDefault(require("../i18n/i18n"));

var errorHandler = function errorHandler(_ref) {
  var response = _ref.response;
  var status = response.status;

  switch (status) {
    case 500:
      throw new Error(_i18n["default"].t('fulfillmentConfigurationList:actions.error500'));

    case 403:
    case 401:
      throw new Error(_i18n["default"].t('fulfillmentConfigurationList:actions.permissionsError'));

    default:
      throw new Error(_i18n["default"].t('fulfillmentConfigurationList:actions.unknownError'));
  }
};

exports.errorHandler = errorHandler;

var fetchFulfillmentConfigurationAssociations = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref2) {
    var accessToken, buyerAccountId, productConfigurationUrl, environment, associationsServiceResponse;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            accessToken = _ref2.accessToken, buyerAccountId = _ref2.buyerAccountId, productConfigurationUrl = _ref2.productConfigurationUrl, environment = _ref2.environment;
            _context.next = 3;
            return fetch("".concat((0, _constants.FULFILLMENT_CONFIGURATION_ASSOCIATIONS_BASE_URL)(environment), "/v1/fulfillmentConfigurationAgreements") + "/fulfillment-configuration?".concat(new URLSearchParams({
              buyerAccountId: buyerAccountId,
              productConfigurationUrl: productConfigurationUrl
            })), {
              method: 'GET',
              headers: {
                Authorization: "Bearer ".concat(accessToken),
                'Content-Type': 'application/json',
                Accept: 'application/json; charset=utf-8'
              }
            });

          case 3:
            associationsServiceResponse = _context.sent;

            if (!associationsServiceResponse.ok) {
              errorHandler({
                response: associationsServiceResponse
              });
            }

            return _context.abrupt("return", associationsServiceResponse.json());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFulfillmentConfigurationAssociations(_x) {
    return _ref3.apply(this, arguments);
  };
}();

exports.fetchFulfillmentConfigurationAssociations = fetchFulfillmentConfigurationAssociations;

var fetchFulfillmentConfigurationResourceByLink = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref4) {
    var accessToken, fulfillmentConfigurationUrl, fulfillmentConfigurationResponse;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            accessToken = _ref4.accessToken, fulfillmentConfigurationUrl = _ref4.fulfillmentConfigurationUrl;
            _context2.next = 3;
            return fetch(fulfillmentConfigurationUrl, {
              method: 'GET',
              headers: {
                Authorization: "Bearer ".concat(accessToken),
                'Content-Type': 'application/json',
                Accept: 'application/json; charset=utf-8'
              }
            });

          case 3:
            fulfillmentConfigurationResponse = _context2.sent;

            if (fulfillmentConfigurationResponse.ok) {
              _context2.next = 9;
              break;
            }

            if (!(fulfillmentConfigurationResponse.status === 404)) {
              _context2.next = 8;
              break;
            }

            // eslint-disable-next-line no-console
            console.log("404 from FCAPI: ".concat(fulfillmentConfigurationUrl));
            return _context2.abrupt("return", null);

          case 8:
            errorHandler({
              response: fulfillmentConfigurationResponse
            });

          case 9:
            return _context2.abrupt("return", fulfillmentConfigurationResponse.json());

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchFulfillmentConfigurationResourceByLink(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

exports.fetchFulfillmentConfigurationResourceByLink = fetchFulfillmentConfigurationResourceByLink;

var getFulfillmentConfigurationsList = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref6) {
    var accessToken, buyerAccountId, productConfigurationUrl, environment, associationsServiceResponse, embeddedItemList, fulfillmentConfigurationPromises, fullFulfillmentConfigurationsList;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            accessToken = _ref6.accessToken, buyerAccountId = _ref6.buyerAccountId, productConfigurationUrl = _ref6.productConfigurationUrl, environment = _ref6.environment;
            _context3.next = 3;
            return fetchFulfillmentConfigurationAssociations({
              accessToken: accessToken,
              buyerAccountId: buyerAccountId,
              productConfigurationUrl: productConfigurationUrl,
              environment: environment
            });

          case 3:
            associationsServiceResponse = _context3.sent;
            embeddedItemList = (0, _lodash.get)(associationsServiceResponse, '_embedded.item', []);
            fulfillmentConfigurationPromises = embeddedItemList.map(function (_ref8) {
              var fulfillmentConfigurationUrl = _ref8._links.self.href;
              return fetchFulfillmentConfigurationResourceByLink({
                accessToken: accessToken,
                fulfillmentConfigurationUrl: fulfillmentConfigurationUrl
              });
            });
            _context3.next = 8;
            return Promise.all(fulfillmentConfigurationPromises);

          case 8:
            fullFulfillmentConfigurationsList = _context3.sent;
            return _context3.abrupt("return", fullFulfillmentConfigurationsList.filter(Boolean).map(function (_ref9) {
              var fulfillmentConfigurationId = _ref9.fulfillmentConfigurationId,
                  name = _ref9.name;
              return {
                fulfillmentConfigurationId: fulfillmentConfigurationId,
                fulfillmentConfigurationName: name
              };
            }));

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getFulfillmentConfigurationsList(_x3) {
    return _ref7.apply(this, arguments);
  };
}();

exports.getFulfillmentConfigurationsList = getFulfillmentConfigurationsList;